export default "__VITE_ASSET__27cd7ac6__"